import Styles from './ResponseBar.scss';

import Template from './ResponseBar.hbs';
import ProgressBar from 'views/components/progressBar/ProgressBar.svelte';

export default BaseView.extend({

    initialize(options) {

        // Shorten response object for readability
        var response = options.response;

        // Create the view, passing the styling with it
        this.setElement(Template({
            Styles,
            count: response.count,
            isCheckingAnswers: options.slideState === 2,
            isCorrect: response.correct
        }));

        let barColor = 'red'
        if (options.slideState === 1) {
            barColor = 'gray'
        } else if (response.correct) {
            barColor = 'green'
        }

        this.addSvelteChildView('.js-response-bar', ProgressBar, {
            fragments: {
                // Amount of answer given compared to total answers given
                [barColor]: response.count / options.responseTotal,
            },
            isLarge: true,
        })

    }

});
